module.exports = __webpack_public_path__ + "img/pq-hight-img.2a2cf0a4.png";